import { skipToken, useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { AISuggestedDocumentsResponse } from '../types';

const getAISuggestedDocuments = async (dealId: number): Promise<AISuggestedDocumentsResponse> => {
    const response = await axiosInstance.get(API_ENDPOINTS.DEAL_DOCUMENTS.AI_SUGGESTIONS(dealId));
    return response.data;
};

interface UseDocumentSuggestionsProps {
    dealId?: number;
}

export const useDocumentSuggestions = ({ dealId }: UseDocumentSuggestionsProps) => useQuery({
    queryKey: [QUERY_KEYS.DOCUMENT_AI_SUGGESTIONS, dealId],
    queryFn: (dealId ? () => getAISuggestedDocuments(dealId) : skipToken),
});
